/* Ivory Floral storefront — vanilla JS, no jQuery dependency */
(function () {
  'use strict';

  var cfg = window.ivTheme || {};
  var S = cfg.strings || {};

  /* ---------------- helpers ---------------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || cfg.moneyFormat || '{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    function fmt(n, precision, thousands, decimal) {
      thousands = thousands === undefined ? ',' : thousands;
      decimal = decimal === undefined ? '.' : decimal;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(precision);
      var parts = n.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function setCookie(name, value, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    document.cookie = name + '=' + encodeURIComponent(value) + '; expires=' + d.toUTCString() + '; path=/';
  }

  var toastEl, toastTimer;
  function toast(html) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'iv-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = html;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3500);
  }

  function setCartCount(count) {
    $$('[data-iv-cart-count], [data-cart-count], .cart-count').forEach(function (el) { el.textContent = count; });
  }
  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); return c; })
      .catch(function () {});
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var msg = (data && (data.description || data.message)) || 'Something went wrong. Please try again.';
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  function todayISO(offsetDays) {
    var d = new Date();
    d.setDate(d.getDate() + (offsetDays || 0));
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return d.getFullYear() + '-' + m + '-' + day;
  }

  /* ---------------- wishlist (shares cookie with legacy theme) ---------------- */
  var WISH = cfg.wishlistCookie || 'wishlistList';
  function wishList() {
    var raw = getCookie(WISH);
    return raw ? raw.split('__').filter(Boolean) : [];
  }
  function updateWishCount() {
    var n = wishList().length;
    $$('[data-iv-wish-count]').forEach(function (el) { el.textContent = n; });
    $$('[data-iv-wish]').forEach(function (btn) {
      var on = wishList().indexOf(btn.getAttribute('data-iv-wish')) > -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-iv-wish]');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-iv-wish');
    var list = wishList();
    var i = list.indexOf(handle);
    if (i > -1) { list.splice(i, 1); toast('Removed from wishlist'); }
    else { list.push(handle); toast('Saved to wishlist'); }
    setCookie(WISH, list.join('__'), 14);
    updateWishCount();
  });

  /* ---------------- announcement bar ---------------- */
  function initAnnouncement() {
    $$('[data-iv-announce]').forEach(function (bar) {
      if (bar.__ivInit) return; bar.__ivInit = true;
      var msgs = $$('.iv-announce__msg', bar);
      if (msgs.length < 2) return;
      var idx = 0;
      var interval = parseInt(bar.getAttribute('data-interval'), 10) || 5000;
      function show(n) {
        msgs[idx].classList.remove('is-active');
        idx = (n + msgs.length) % msgs.length;
        msgs[idx].classList.add('is-active');
      }
      var timer = setInterval(function () { show(idx + 1); }, interval);
      function reset() { clearInterval(timer); timer = setInterval(function () { show(idx + 1); }, interval); }
      var prev = $('[data-iv-announce-prev]', bar), next = $('[data-iv-announce-next]', bar);
      if (prev) prev.addEventListener('click', function () { show(idx - 1); reset(); });
      if (next) next.addEventListener('click', function () { show(idx + 1); reset(); });
    });
  }

  /* ---------------- header: search + drawer ---------------- */
  function initHeader() {
    var search = $('[data-iv-search]');
    $$('[data-iv-search-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!search) return;
        search.classList.add('is-open');
        var input = $('input[type="search"]', search);
        if (input) setTimeout(function () { input.focus(); }, 50);
      });
    });
    $$('[data-iv-search-close]').forEach(function (b) { b.addEventListener('click', function () { search.classList.remove('is-open'); }); });
    if (search) search.addEventListener('click', function (e) { if (e.target === search) search.classList.remove('is-open'); });

    var drawer = $('[data-iv-drawer]');
    var opener = $('[data-iv-drawer-open]');
    function setDrawer(open) {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
      if (open) { var c = $('[data-iv-drawer-close].iv-drawer__close', drawer); if (c) c.focus(); }
      else if (opener) opener.focus();
    }
    if (opener) opener.addEventListener('click', function () { setDrawer(true); });
    $$('[data-iv-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (search && search.classList.contains('is-open')) search.classList.remove('is-open');
      if (drawer && drawer.classList.contains('is-open')) setDrawer(false);
      var lb = $('.iv-lightbox.is-open'); if (lb) lb.classList.remove('is-open');
    });
  }

  /* ---------------- carousels ---------------- */
  function initCarousel(root) {
    if (root.__ivCarousel) { root.__ivCarousel(); return; }
    var track = $('[data-iv-track]', root);
    if (!track) return;
    var dots = $('[data-iv-dots]', root);
    var prev = $('[data-iv-prev]', root);
    var next = $('[data-iv-next]', root);

    function pageWidth() { return track.clientWidth; }
    function pages() {
      var w = pageWidth();
      return w ? Math.max(1, Math.ceil((track.scrollWidth - 4) / w)) : 1;
    }
    function current() { return Math.round(track.scrollLeft / Math.max(1, pageWidth())); }
    function build() {
      var n = pages();
      if (dots) {
        dots.innerHTML = '';
        if (n > 1) {
          for (var i = 0; i < n; i++) {
            var d = document.createElement('button');
            d.type = 'button';
            d.className = 'iv-carousel__dot';
            d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            d.addEventListener('click', (function (p) { return function () { track.scrollTo({ left: p * pageWidth(), behavior: 'smooth' }); }; })(i));
            dots.appendChild(d);
          }
        }
      }
      sync();
    }
    function sync() {
      var c = current(), n = pages();
      if (dots) $$('.iv-carousel__dot', dots).forEach(function (d, i) { d.classList.toggle('is-active', i === Math.min(c, n - 1)); });
      if (prev) prev.hidden = track.scrollLeft <= 2;
      if (next) next.hidden = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }
    var t;
    track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -pageWidth(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: pageWidth(), behavior: 'smooth' }); });
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(build, 150); });
    root.__ivCarousel = build;
    build();
  }
  function initCarousels(scope) { $$('[data-iv-carousel]', scope).forEach(initCarousel); }

  /* ---------------- quantity steppers (delegated) ---------------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-iv-qty-minus]');
    var plus = e.target.closest('[data-iv-qty-plus]');
    if (!minus && !plus) return;
    var wrap = e.target.closest('[data-iv-qty]');
    var input = wrap && $('input', wrap);
    if (!input) return;
    var min = parseInt(input.min, 10); if (isNaN(min)) min = 1;
    var v = parseInt(input.value, 10) || 0;
    v = plus ? v + 1 : Math.max(min, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- quick add from cards ---------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-iv-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = S.adding || 'Adding…';
    postJSON('/cart/add.js', { items: [{ id: Number(btn.getAttribute('data-iv-quick-add')), quantity: 1 }] })
      .then(function () {
        return refreshCartCount();
      })
      .then(function () { toast((S.added || 'Added to cart') + ' <a href="' + (cfg.cartUrl || '/cart') + '">View cart</a>'); })
      .catch(function (err) { toast(err.message); })
      .then(function () { btn.disabled = false; btn.textContent = label; });
  });

  /* ---------------- back to top + video ---------------- */
  function initFloating() {
    var top = $('[data-iv-top]');
    if (top) {
      var onScroll = function () { top.classList.toggle('is-visible', window.scrollY > 600); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
    }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      $$('[data-iv-video]').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
    }
  }

  /* ---------------- product page ---------------- */
  function initProduct(root) {
    var jsonEl = $('[data-iv-product-json]', root);
    var product = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var form = $('[data-iv-product-form]', root) || $('form[action*="/cart/add"]', root);
    if (!product || !form) return;

    var idSelect = $('[data-iv-variant-id]', form);
    var errorEl = $('[data-iv-error]', form);
    var atc = $('[data-iv-atc]', form);
    var buyNow = $('[data-iv-buy-now]', form);
    var terms = $('[data-iv-terms]', form);
    var availability = $('[data-iv-availability]', form);
    var priceNow = $('[data-iv-price-current]', root);
    var priceWas = $('[data-iv-price-compare]', root);

    function setError(msg) { if (errorEl) errorEl.textContent = msg || ''; }

    /* gallery */
    var slides = $$('.iv-gallery__slide', root);
    var thumbs = $$('[data-iv-thumb]', root);
    function showImage(id) {
      var found = false;
      slides.forEach(function (s) {
        var on = String(s.getAttribute('data-image-id')) === String(id);
        if (on) found = true;
        s.classList.toggle('is-active', on);
      });
      if (!found && slides[0]) slides[0].classList.add('is-active');
      thumbs.forEach(function (t) { t.classList.toggle('is-active', String(t.getAttribute('data-iv-thumb')) === String(id)); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { showImage(t.getAttribute('data-iv-thumb')); }); });

    var lightbox = $('[data-iv-lightbox]', root);
    var zoom = $('[data-iv-zoom]', root);
    if (zoom && lightbox) {
      zoom.addEventListener('click', function () {
        var active = $('.iv-gallery__slide.is-active', root);
        $('img', lightbox).src = active ? active.getAttribute('data-full') : '';
        lightbox.classList.add('is-open');
        $('[data-iv-lightbox-close]', lightbox).focus();
      });
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox || e.target.closest('[data-iv-lightbox-close]')) { lightbox.classList.remove('is-open'); zoom.focus(); }
      });
    }

    /* variants */
    var optionInputs = $$('[data-iv-option]', form);
    function selectedOptions() {
      var opts = [];
      product.options.forEach(function (_, i) {
        var checked = $('[data-iv-option="' + (i + 1) + '"]:checked', form);
        opts.push(checked ? checked.value : null);
      });
      return opts;
    }
    function findVariant(opts) {
      return product.variants.filter(function (v) {
        return v.options.every(function (o, i) { return opts[i] === null || o === opts[i]; });
      })[0];
    }
    function updateVariant() {
      var v = findVariant(selectedOptions());
      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = 'Unavailable'; }
        if (buyNow) buyNow.disabled = true;
        return;
      }
      if (idSelect) idSelect.value = v.id;
      if (priceNow) priceNow.textContent = formatMoney(v.price);
      if (priceWas) {
        var sale = v.compare_at_price && v.compare_at_price > v.price;
        priceWas.hidden = !sale;
        if (sale) priceWas.textContent = formatMoney(v.compare_at_price);
      }
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? (S.addToCart || 'Add to cart') : (S.soldOut || 'Sold out'); }
      if (buyNow) buyNow.disabled = !v.available;
      if (availability) availability.textContent = v.available ? 'In stock' : 'Out of stock';
      if (v.featured_image) showImage(v.featured_image.id);
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
      // mark impossible combinations on the last option
      optionInputs.forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-iv-option'), 10) - 1;
        var opts = selectedOptions(); opts[pos] = input.value;
        var match = product.variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
        input.closest('.iv-variant-pill').classList.toggle('is-unavailable', !match || !match.available);
      });
    }
    optionInputs.forEach(function (i) { i.addEventListener('change', updateVariant); });
    if (optionInputs.length) updateVariant();

    /* add-on tabs */
    $$('[data-iv-addons]', root).forEach(function (box) {
      var tabs = $$('[data-iv-addon-tab]', box);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var key = tab.getAttribute('data-iv-addon-tab');
          tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
          $$('[data-iv-addon-panel]', box).forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-iv-addon-panel') === key); });
        });
      });
    });

    /* delivery date + slots */
    var dateInput = $('[data-iv-date]', form);
    var slotSelect = $('[data-iv-slot]', form);
    var closed = [];
    if (dateInput) {
      var cutoff = parseInt(dateInput.getAttribute('data-cutoff'), 10) || 0;
      var maxDays = parseInt(dateInput.getAttribute('data-max-days'), 10) || 60;
      closed = (dateInput.getAttribute('data-closed') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      var minOffset = (cutoff > 0 && new Date().getHours() >= cutoff) ? 1 : 0;
      dateInput.min = todayISO(minOffset);
      dateInput.max = todayISO(maxDays);
      dateInput.addEventListener('change', function () {
        setError('');
        var v = dateInput.value;
        if (v && (v < dateInput.min || v > dateInput.max)) {
          setError('Please choose a date between ' + dateInput.min + ' and ' + dateInput.max + '.');
          dateInput.value = '';
        } else if (v && closed.indexOf(v) > -1) {
          setError(dateInput.getAttribute('data-closed-msg') || 'We are closed on that date.');
          dateInput.value = '';
        }
        filterSlots();
      });
    }

    function slotStartMinutes(label) {
      var m = label.match(/(\d{1,2})(?::(\d{2}))?\s*(am|pm)?/i);
      if (!m) return null;
      var h = parseInt(m[1], 10), min = parseInt(m[2] || '0', 10), ap = (m[3] || '').toLowerCase();
      if (ap === 'pm' && h < 12) h += 12;
      if (ap === 'am' && h === 12) h = 0;
      return h * 60 + min;
    }
    function filterSlots() {
      if (!slotSelect) return;
      var lead = (parseInt(slotSelect.getAttribute('data-lead'), 10) || 0) * 60;
      var isToday = dateInput && dateInput.value === todayISO(0);
      var now = new Date();
      var nowMin = now.getHours() * 60 + now.getMinutes();
      $$('option', slotSelect).forEach(function (o) {
        if (!o.value) return;
        var start = slotStartMinutes(o.value);
        var off = isToday && start !== null && start < nowMin + lead;
        o.disabled = off;
        if (off && o.selected) slotSelect.value = '';
      });
    }
    filterSlots();

    /* terms gating */
    function termsOk(forBuyNow) {
      if (!terms) return true;
      var mode = terms.getAttribute('data-iv-terms');
      if (mode === 'both' || (mode === 'buy_now' && forBuyNow)) return terms.checked;
      return true;
    }
    if (terms) terms.addEventListener('change', function () { if (terms.checked) setError(''); });

    function validate(forBuyNow) {
      var fields = $$('[data-iv-required]', form);
      for (var i = 0; i < fields.length; i++) {
        var f = fields[i];
        if (!String(f.value || '').trim()) {
          setError(f.getAttribute('data-iv-required'));
          f.focus();
          if (f.scrollIntoView) f.scrollIntoView({ block: 'center', behavior: 'smooth' });
          return false;
        }
      }
      if (!termsOk(forBuyNow)) {
        setError(S.agreeTerms || 'Please agree to the Terms & Conditions first.');
        terms.focus();
        return false;
      }
      setError('');
      return true;
    }

    function buildItems() {
      var fd = new FormData(form);
      var props = {};
      fd.forEach(function (val, key) {
        var m = key.match(/^properties\[(.+)\]$/);
        if (m && String(val).trim() !== '') props[m[1]] = String(val).trim();
      });
      var qty = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
      var items = [{ id: Number(fd.get('id')), quantity: qty, properties: props }];
      $$('[data-iv-addon]:checked', form).forEach(function (cb) {
        var p = { 'Add-on for': product.title };
        Object.keys(props).forEach(function (k) { if (/date|slot/i.test(k)) p[k] = props[k]; });
        items.push({ id: Number(cb.value), quantity: 1, properties: p });
      });
      return items;
    }

    function submit(forBuyNow, btn) {
      if (!validate(forBuyNow)) return;
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = S.adding || 'Adding…'; }
      postJSON('/cart/add.js', { items: buildItems() })
        .then(function () {
          if (forBuyNow) { window.location.href = '/checkout'; return; }
          if (root.getAttribute('data-after-add') === 'cart') { window.location.href = cfg.cartUrl || '/cart'; return; }
          $$('[data-iv-addon]:checked', form).forEach(function (cb) { cb.checked = false; });
          return refreshCartCount().then(function () {
            toast((S.added || 'Added to cart') + ' <a href="' + (cfg.cartUrl || '/cart') + '">View cart</a>');
            if (btn) { btn.disabled = false; btn.textContent = label; }
          });
        })
        .catch(function (err) {
          setError(err.message);
          if (btn) { btn.disabled = false; btn.textContent = label; }
        });
    }

    form.addEventListener('submit', function (e) { e.preventDefault(); submit(false, atc); });
    if (buyNow) buyNow.addEventListener('click', function () { submit(true, buyNow); });

    /* share */
    var share = $('[data-iv-share]', root);
    if (share) {
      share.addEventListener('click', function () {
        var data = { title: share.getAttribute('data-title'), url: share.getAttribute('data-url') };
        if (navigator.share) { navigator.share(data).catch(function () {}); }
        else if (navigator.clipboard) { navigator.clipboard.writeText(data.url).then(function () { toast(S.linkCopied || 'Link copied'); }); }
      });
    }

    /* remember for "recently viewed" */
    try {
      var key = 'ivRecentlyViewed';
      var list = JSON.parse(localStorage.getItem(key) || '[]').filter(function (h) { return h !== product.handle; });
      list.unshift(product.handle);
      localStorage.setItem(key, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }

  /* ---------------- recommendations ---------------- */
  function initRecos() {
    $$('[data-iv-recos]').forEach(function (sec) {
      var url = sec.getAttribute('data-url');
      if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = $('[data-iv-recos-track]', tmp);
        var track = $('[data-iv-recos-track]', sec);
        if (fresh && track && fresh.children.length) {
          track.innerHTML = fresh.innerHTML;
          var c = $('[data-iv-carousel]', sec); if (c) initCarousel(c);
        }
        if (track && !track.children.length) sec.hidden = true;
      }).catch(function () {
        var track = $('[data-iv-recos-track]', sec);
        if (track && !track.children.length) sec.hidden = true;
      });
    });
  }

  /* ---------------- recently viewed ---------------- */
  function initRecent() {
    var sec = $('[data-iv-recent]');
    if (!sec) return;
    var list;
    try { list = JSON.parse(localStorage.getItem('ivRecentlyViewed') || '[]'); } catch (e) { list = []; }
    var limit = parseInt(sec.getAttribute('data-limit'), 10) || 4;
    list = list.slice(0, limit);
    if (!list.length) return;
    var tpl = $('[data-iv-card-template]', sec);
    var track = $('[data-iv-recent-track]', sec);
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (products) {
      products.filter(Boolean).forEach(function (p) {
        var node = tpl.content.cloneNode(true);
        $$('[data-href]', node).forEach(function (a) { a.href = p.url || ('/products/' + p.handle); });
        var img = $('[data-img]', node);
        if (p.featured_image) {
          var src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600&height=600&crop=center';
          img.src = src; img.alt = p.title;
        } else { img.remove(); }
        $('[data-title]', node).textContent = p.title;
        var price = $('[data-price]', node);
        price.textContent = (p.price_varies ? 'From ' : '') + formatMoney(p.price);
        if (p.compare_at_price && p.compare_at_price > p.price) {
          var s = document.createElement('s'); s.textContent = formatMoney(p.compare_at_price); price.appendChild(s);
        }
        track.appendChild(node);
      });
      if (track.children.length) {
        sec.hidden = false;
        var c = $('[data-iv-carousel]', sec); if (c) initCarousel(c);
      }
    });
  }

  /* ---------------- cart page ---------------- */
  function initCart(root) {
    if (!root) return;
    var terms = $('[data-iv-cart-terms]', root);
    var checkout = $('[data-iv-checkout]', root);
    var err = $('[data-iv-cart-error]', root);
    if (terms && checkout) {
      terms.addEventListener('change', function () {
        checkout.classList.toggle('is-disabled', !terms.checked);
        if (terms.checked && err) err.textContent = '';
      });
      checkout.addEventListener('click', function (e) {
        if (!terms.checked) {
          e.preventDefault();
          if (err) err.textContent = S.agreeTerms || 'Please agree to the Terms & Conditions first.';
          terms.focus();
        }
      });
    }

    var note = $('[data-iv-cart-note]', root);
    if (note) {
      var nt;
      note.addEventListener('input', function () {
        clearTimeout(nt);
        nt = setTimeout(function () { postJSON('/cart/update.js', { note: note.value }).catch(function () {}); }, 500);
      });
    }

    function renderCart(sections) {
      if (!sections || !sections['iv-cart']) { window.location.reload(); return; }
      var tmp = document.createElement('div');
      tmp.innerHTML = sections['iv-cart'];
      var fresh = $('[data-iv-cart]', tmp);
      if (!fresh) { window.location.reload(); return; }
      var wasChecked = terms && terms.checked;
      root.innerHTML = fresh.innerHTML;
      initCart(root);
      initCarousels(root);
      var t2 = $('[data-iv-cart-terms]', root);
      if (t2 && wasChecked) { t2.checked = true; t2.dispatchEvent(new Event('change')); }
    }

    function changeLine(key, qty, row) {
      if (row) row.classList.add('is-loading');
      postJSON('/cart/change.js', { id: key, quantity: qty, sections: 'iv-cart', sections_url: window.location.pathname })
        .then(function (cart) { setCartCount(cart.item_count); renderCart(cart.sections); })
        .catch(function (e) {
          if (row) row.classList.remove('is-loading');
          if (err) err.textContent = e.message;
        });
    }

    $$('[data-iv-line-qty]', root).forEach(function (input) {
      input.addEventListener('change', function () {
        var q = Math.max(0, parseInt(input.value, 10) || 0);
        changeLine(input.getAttribute('data-iv-line-qty'), q, input.closest('.iv-cart__row'));
      });
    });
    $$('[data-iv-remove]', root).forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        changeLine(a.getAttribute('data-iv-remove'), 0, a.closest('.iv-cart__row'));
      });
    });
    $$('[data-iv-cart-add]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var label = b.textContent;
        b.disabled = true; b.textContent = S.adding || 'Adding…';
        postJSON('/cart/add.js', { items: [{ id: Number(b.getAttribute('data-iv-cart-add')), quantity: 1 }], sections: 'iv-cart', sections_url: window.location.pathname })
          .then(function (res) { return refreshCartCount().then(function () { renderCart(res.sections); }); })
          .catch(function (e) { b.disabled = false; b.textContent = label; toast(e.message); });
      });
    });
  }

  /* ---------------- boot ---------------- */
  function boot() {
    initAnnouncement();
    initHeader();
    initCarousels(document);
    initFloating();
    updateWishCount();
    $$('[data-iv-product]').forEach(initProduct);
    initRecos();
    initRecent();
    initCart($('[data-iv-cart]'));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor: re-init sections when they are re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    initCarousels(t);
    $$('[data-iv-product]', t).forEach(initProduct);
    initAnnouncement();
    initCart($('[data-iv-cart]', t));
  });

  window.ivTheme.formatMoney = formatMoney;
})();
